import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  BuildingFilterDto,
  BuildingService,
  BuildingWorkItemDto,
  RegionItemDto,
  TeamItemDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import TenantTypeEnum = BuildingFilterDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-work-item-overview-page',
  templateUrl: './building-work-item-overview-page.component.html',
  styleUrls: ['./building-work-item-overview-page.component.scss'],
})
export class BuildingWorkItemOverviewPageComponent {

  private readonly router = inject(Router);
  private readonly buildingService = inject(BuildingService);
  private readonly formBuilder = inject(FormBuilder);

  form!: FormGroup;

  readonly loadBuildings = (filter: BuildingFilterDto) => this.buildingService.findAllWorkItems({ ...filter, tenantType: TenantTypeEnum.External });
  readonly getCount = (filter: BuildingFilterDto) => this.buildingService.getCount({ ...filter, tenantType: TenantTypeEnum.External });

  constructor() {
    this.form = this.formBuilder.group({
      fullTextSearch: this.formBuilder.control(''),
      ownerTenantId: this.formBuilder.control<string | null>(null),
      region: this.formBuilder.control<RegionItemDto | null>(null),
      regionId: this.formBuilder.control<string | null>(null),
      team: this.formBuilder.control<TeamItemDto | null>(null),
      teamId: this.formBuilder.control<string | null>(null),
      assignedInternalTenantId: this.formBuilder.control<string | null>(null),
      hasMonitoring: this.formBuilder.control<boolean | null>(null),
    });

    this.form.get('region')?.valueChanges.subscribe((region) => {
      if (region) {
        this.form.get('regionId')?.setValue(region.id);
      } else {
        this.form.get('regionId')?.setValue(null);
      }
    });

    this.form.get('team')?.valueChanges.subscribe((team) => {
      if (team) {
        this.form.get('teamId')?.setValue(team.id);
      } else {
        this.form.get('teamId')?.setValue(null);
      }
    });
  }

  navigateToBuilding(event: BuildingWorkItemDto): void {
    this.router.navigate(['building', event.id]);
  }

  add(): void {
    this.router.navigate(['building', 'new']);
  }

  protected readonly TenantTypeEnum = TenantTypeEnum;
  protected readonly signal = signal;

  displayAssignedInternalTenants(assignedInternalTenants: string[]): string {
    if (assignedInternalTenants.length > 0) {
      return assignedInternalTenants.join(', ');
    }
    return 'keine Firmen';
  }

  readonly exportAssignedInternalTenants = (building: BuildingWorkItemDto): string =>
    this.displayAssignedInternalTenants(building.assignedInternalTenants);

  readonly exportMonitoring = (building: BuildingWorkItemDto): string =>
    building.hasMonitoring ? 'Ja' : 'Nein';
}
